const badge = {
  MuiBadge: {
    styleOverrides: {
      badge: {
        fontSize: '11px',
        fontWeight: 700,
        minWidth: 18,
        height: 18,
        padding: 0,
      },
      anchorOriginTopRightRectangular: {
        top: 2,
        right: 2,
      },
    },
  },
};

export default badge;
